var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "right-body",
      attrs: {
        id: "rightBodyList",
        "element-loading-background": "rgba(0, 0, 0, 0)"
      },
      on: { click: _vm.filterMenuClose }
    },
    [
      _c(
        "div",
        {
          directives: [{ name: "loading", rawName: "v-loading" }],
          staticClass: "right-body-box",
          style: _vm.showBatchDel ? "height: calc(100% - 91px);" : "",
          attrs: { "element-loading-background": "rgba(0, 0, 0, 0.05)" }
        },
        [
          _c("div", { staticClass: "task-list-functions" }, [
            _vm.taskListOriginal.length > 5
              ? _c("div", {
                  staticClass: "icon-function delete",
                  class: _vm.showBatchDel ? "delete-red" : "delete",
                  on: {
                    click: function($event) {
                      return _vm.changeBatchDel()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.taskListOriginal.length > 5
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "rightclickoutside",
                        rawName: "v-rightclickoutside",
                        value: _vm.dateControlsClose,
                        expression: "dateControlsClose"
                      }
                    ],
                    staticClass: "icon-function funnel",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.filterMenuShow = true
                      }
                    }
                  },
                  [
                    _vm.filterMenuShow
                      ? _c(
                          "div",
                          {
                            staticClass: "screen-options filter-menu",
                            style:
                              _vm.lang == "jp" ? "right:-20px;width:130px;" : ""
                          },
                          _vm._l(_vm.filterMenu, function(menu, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "screen-option filter-menu-item",
                                on: {
                                  mouseenter: function($event) {
                                    return _vm.switchMenu(index)
                                  },
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.switchMenu(index)
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "icon-util filter-triangle filter-triangle-position"
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "language.filters.taskList." + menu.name
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _vm.filterIndex - 1 == index
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "type-menu",
                                        style:
                                          _vm.lang == "jp" ? "right:130px;" : ""
                                      },
                                      _vm._l(menu.children, function(type) {
                                        return _c(
                                          "div",
                                          {
                                            key: type.id,
                                            staticClass: "type-menu-item",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.chickFilterState(
                                                  index + 1,
                                                  type.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            index == 0
                                              ? _c("div", {
                                                  staticClass:
                                                    "icon-util tick-purple-position",
                                                  class: {
                                                    "tick-purple":
                                                      _vm.filterState == type.id
                                                  }
                                                })
                                              : _c("div", {
                                                  staticClass:
                                                    "icon-util tick-purple-position",
                                                  class: {
                                                    "tick-purple":
                                                      _vm.filterDate == type.id
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "filter-type-name"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.filters.taskList." +
                                                        type.name
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.timeSetShow
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "clickoutside",
                                rawName: "v-clickoutside",
                                value: _vm.dateControlsClose,
                                expression: "dateControlsClose"
                              }
                            ],
                            staticClass: "time-set",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [
                            _c("date-selector", {
                              ref: "freeFilterDate",
                              staticStyle: { margin: "8Px 8Px 8Px 10Px" }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "time-set-button",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.saveTimeFilter()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.taskListOriginal.length > 0
              ? _c("div", { staticClass: "task-list-switch-tab" }, [
                  _c(
                    "div",
                    {
                      staticClass: "icon-switch-tab",
                      class: {
                        "icon-switch-tab-this": _vm.listContentShow == 1
                      }
                    },
                    [
                      _c("div", {
                        class: _vm.listContentShow == 1 ? "list-white" : "list",
                        attrs: {
                          "data-title": _vm.$t("language.cloudExploer.grid")
                        },
                        on: {
                          click: function($event) {
                            return _vm.changelistContentShow(1)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "icon-switch-tab",
                      class: {
                        "icon-switch-tab-this": _vm.listContentShow == 2
                      }
                    },
                    [
                      _c("div", {
                        class: _vm.listContentShow == 2 ? "grid-white" : "grid",
                        attrs: {
                          "data-title": _vm.$t("language.cloudExploer.pageList")
                        },
                        on: {
                          click: function($event) {
                            return _vm.changelistContentShow(2)
                          }
                        }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              { staticClass: "task-list-tab-titles" },
              _vm._l(_vm.tabTitleTypes, function(type) {
                return _c("div", { key: type.id }, [
                  (type.id == 100
                  ? true
                  : _vm.tabTitleShowNum > 2
                  ? type.haveTask
                  : false)
                    ? _c(
                        "div",
                        {
                          staticClass: "task-list-tab-title",
                          class: { "tab-this": _vm.filterType == type.id }
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.chickFilterState(0, type.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "language.filters.taskList." + type.name
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "div",
                  {
                    staticClass: "task-list-initial",
                    class:
                      !_vm.haveTaskData || _vm.filteredList.length
                        ? ""
                        : "task-filter-none"
                  },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.isLoading,
                          expression: "isLoading"
                        }
                      ],
                      staticClass: "loading-img"
                    }),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("language.common.load")))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.taskList.loadingTip")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.haveTaskData || !_vm.filteredList.length,
                    expression: "!haveTaskData||!filteredList.length"
                  }
                ],
                staticClass: "task-list-initial",
                class:
                  !_vm.haveTaskData || _vm.filteredList.length
                    ? ""
                    : "task-filter-none"
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/task-icon/no_task_bg.png")
                  }
                }),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("language.taskList.noTasks")))
                ]),
                _vm._v(" "),
                _vm.taskListOriginal.length < 1
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.taskList.noTasksTip")))
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.haveTaskData,
                    expression: "haveTaskData"
                  }
                ],
                staticClass: "task-list-tab-content"
              },
              [
                _vm.listContentShow == 1
                  ? _c(
                      "div",
                      { ref: "tasksCards", staticClass: "task-list-grid" },
                      [
                        _vm.showBatchDel
                          ? _c(
                              "el-checkbox",
                              {
                                staticStyle: { height: "32px" },
                                attrs: { indeterminate: _vm.isDeleteAll },
                                on: { change: _vm.deleteHandleCheckAllChange },
                                model: {
                                  value: _vm.deleteCheckAll,
                                  callback: function($$v) {
                                    _vm.deleteCheckAll = $$v
                                  },
                                  expression: "deleteCheckAll"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.taskList.allTasks", {
                                      num: _vm.filteredList.length
                                    })
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            class: _vm.showBatchDel ? "batchDel" : "",
                            model: {
                              value: _vm.checkDeleteList,
                              callback: function($$v) {
                                _vm.checkDeleteList = $$v
                              },
                              expression: "checkDeleteList"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              {
                                staticClass: "task-grid-cards",
                                attrs: { type: "flex", justify: "start" }
                              },
                              _vm._l(_vm.showList, function(task, index) {
                                return _c("singelTaskCard", {
                                  key: index,
                                  attrs: {
                                    item: task,
                                    collapseFlage: _vm.collapseFlage,
                                    eidtTaskFlag: _vm.eidtTaskFlag,
                                    detailShow: _vm.detailShow,
                                    index: index,
                                    tasklistData: _vm.filteredList
                                  },
                                  on: {
                                    "open-function-popup":
                                      _vm.openFunctionPopup,
                                    "execute-task": _vm.executeTask,
                                    "pause-task": _vm.cancelOrPauseTask,
                                    "to-source": _vm.toSourceCatalog,
                                    "to-aim": _vm.toAimCatalog
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("singelTaskForm", {
                  ref: "singelTaskForm",
                  attrs: {
                    tasklistData: _vm.filteredList,
                    listContentShow: _vm.listContentShow,
                    showBatchDel: _vm.showBatchDel,
                    checkDeleteList: _vm.checkDeleteList
                  },
                  on: {
                    "open-function-popup": _vm.openFunctionPopup,
                    "execute-task": _vm.executeTask,
                    "pause-task": _vm.cancelOrPauseTask
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-buttom" })
        ]
      ),
      _vm._v(" "),
      _c("deleteBtns", {
        ref: "deleteBtns",
        attrs: {
          deleteList: _vm.checkDeleteList,
          showBatchDel: _vm.showBatchDel,
          showDelBtn: _vm.showDelBtn
        }
      }),
      _vm._v(" "),
      _c("viewLogsDialog", { ref: "viewLogsDialog" }),
      _vm._v(" "),
      _c("transferOptionsDialog", { ref: "transferOptionsDialog" }),
      _vm._v(" "),
      _c("emailTransferOptionsDialog", { ref: "emailTransferOptionsDialog" }),
      _vm._v(" "),
      _c("syncOptionsDialog", { ref: "syncOptionsDialog" }),
      _vm._v(" "),
      _c("viewBackupLogsDialog", { ref: "viewBackupLogsDialog" }),
      _vm._v(" "),
      _c("backupOptionDialog", { ref: "backupOptionDialog" }),
      _vm._v(" "),
      _c("backupRestoreDialog", { ref: "backupRestoreDialog" }),
      _vm._v(" "),
      _c("versionsDialog", { ref: "versionsDialog" }),
      _vm._v(" "),
      _c("deleteTaskDialog", { ref: "deleteTaskDialog" }),
      _vm._v(" "),
      _c("deleteSelectedTaskDialog", {
        ref: "deleteSelectedTaskDialog",
        attrs: { deleteList: _vm.checkDeleteList },
        on: { "refresh-all": _vm.refreshTaskList }
      }),
      _vm._v(" "),
      _c("transferScheduleDialog", {
        ref: "transferScheduleDialog",
        on: { update: _vm.updateOptionRequest, upgrade: _vm.showUpgrade }
      }),
      _vm._v(" "),
      _c("upgradeDialog", { ref: "upgradeDialog" }),
      _vm._v(" "),
      _c("taskMultiSourcesDialog", {
        ref: "taskMultiSourcesDialog",
        on: {
          "to-source-catalog": _vm.toSourceCatalog,
          "to-aim-catalog": _vm.toAimCatalog
        }
      }),
      _vm._v(" "),
      _c("deleteAttentionDialog", { ref: "deleteAttentionDialog" }),
      _vm._v(" "),
      _c("failedFilesDialog", { ref: "failedFilesDialog" }),
      _vm._v(" "),
      _c("taskProgressDialog", { ref: "taskProgressDialog" }),
      _vm._v(" "),
      _c("taskListProgressControlModule", {
        ref: "taskListProgressControlModule",
        attrs: { taskList: _vm.taskListOriginal },
        on: { "refresh-all": _vm.refreshTaskList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19f7969f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f7969f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/task_list_new.vue
// module id = null
// module chunks = 